import { htmlColors } from ".";

export const htmlColorArr = () => {
  return htmlColors.map((item) => {
    return item.name.toLowerCase();
  });
};
